var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-lg",modifiers:{"modal-lg":true}}],staticClass:"btn btn-primary"},[_vm._v(" Modo de verificación ")])]),_c('b-modal',{attrs:{"id":"modal-lg","size":"lg","title":"Modo verificación","title-class":"font-18","hide-footer":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }